import i18next from 'i18next';
import HttpBackend from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next, useTranslation as useTranslationOrg } from 'react-i18next';
import { i18nextConfig, supportedLanguages } from './next-i18next.config';
import { use, useEffect, useState } from 'react';
import { i18nextDetector, lngDetector } from '@app/i18n/lngDetection/lngDetector';

const runsOnServerSide = typeof window === 'undefined';

const config = {
    ...i18nextConfig(undefined),
    preload: runsOnServerSide ? supportedLanguages : [],
    backend: {
        loadPath: '/locales/{{lng}}.json',
    },
};

export const emptyI18nModule = {
    type: 'emptymodule',
};

const loadResourcesIfOnServerFromFile = () =>
    resourcesToBackend((lang: string) => import(`../../public/locales/${lang}.json`));

i18next
    .use(HttpBackend)
    .use(i18nextDetector as any)
    .use(runsOnServerSide ? loadResourcesIfOnServerFromFile() : (emptyI18nModule as any))
    .use(initReactI18next)
    .init(config);

export function useTranslation() {
    const orgUseTranslations = useTranslationOrg();
    const { i18n } = orgUseTranslations;
    const lang = lngDetector();

    if (runsOnServerSide) {
        // React 19 use() unwraps the async lngDetectorServer promise
        // synchronously during render so i18next has the language before output.
        const { lngDetectorServer } = require('@app/i18n/lngDetection/lngDetector');
        const serverLang = use(lngDetectorServer() as Promise<string>);
        i18n.changeLanguage(serverLang);
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [activeLng, setActiveLng] = useState(i18n.resolvedLanguage);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            if (activeLng === i18n.resolvedLanguage) {
                return;
            }
            setActiveLng(i18n.resolvedLanguage);
        }, [activeLng, i18n.resolvedLanguage]);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            i18n.changeLanguage(lang);
        }, [lang, i18n]);
    }
    return orgUseTranslations;
}
